// extracted by mini-css-extract-plugin
export default {"header":"PecivoTable_header__eCwJo","grid":"PecivoTable_grid__06PWs","input":"PecivoTable_input__Jnekv","title":"PecivoTable_title__XTMT0","content":"PecivoTable_content__2WSEL"};